import { useEffect } from 'react';
import styles, { global } from './styles';
import dynamic from 'next/dynamic';

const DynamicReactPlayer = dynamic(() => import('react-player'), { ssr: false });

const TwoColumnsVideo = ({ block }) => {
  if (!block) return '';
  
  const { primary } = block;

  useEffect(() => {
    let video_thumbnail;
    let videoId;
    if (primary.video_link != '') {
      console.log({ url: primary.video_link });
        videoId = primary.video_link
          .match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/)
          ?.pop();
        if (videoId?.length == 11) {
          video_thumbnail = `https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`;
        }
    }
  })

  return (
    <>
      <div className='container'>
        <div className='section' style={primary.video_position == 'left' ? {flexDirection: 'row'} : {flexDirection: 'row-reverse'}}>
          <div className='video-section'style={primary.video_position == 'left' ? {marginRight: '5%'} : {marginLeft: '5%'}}>
            <DynamicReactPlayer
                className='react-player'
                url={primary.video_link}
                width='100%'
                height='100%'
                controls
              />
          </div>
          
          <div className='description-section'>
            <p className='title'>{primary.title1}</p>
            <p className='description'>{primary.description}</p>
          </div>
        </div>
      </div>
      <style jsx>{styles}</style>
      <style jsx>{global}</style>
    </>
  );
};

export default TwoColumnsVideo;